var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 6C12.9001 6 12.0001 6.9 12.0001 8V36C12.0001 37.1 12.9001 37.9999 14.0001 37.9999H34C35.1 37.9999 36 37.1 36 36V14L28 6H14.0001Z",
    fill: "#E6EBF5",
    fillOpacity: 0.56
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30 14H36L28 6V12C28 13.1 28.9 14 30 14Z",
    fill: "#BBC1C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36 19.9999L30 13.9999H36V19.9999Z",
    fill: "#BBC1C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32C32 32.55 31.55 33 31 33H9C8.45 33 8 32.55 8 32V22C8 21.45 8.45 21 9 21H31C31.55 21 32 21.45 32 22V32Z",
    fill: "#BBC1C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31 32.9999H12.0001V33.9999H31C31.55 33.9999 32 33.5499 32 32.9999V31.9999C32 32.5499 31.55 32.9999 31 32.9999Z",
    fill: "#BBC1C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1447 26.288C17.1447 26.8373 16.9927 27.2666 16.6887 27.576C16.3847 27.8853 15.91 28.04 15.2647 28.04H14.1447V30H13.1287V24.48H15.2647C15.9047 24.48 16.3767 24.6426 16.6807 24.968C16.99 25.288 17.1447 25.728 17.1447 26.288ZM16.0807 26.112C16.0807 25.5946 15.7767 25.336 15.1687 25.336H14.1447V27.184H15.1687C15.7767 27.184 16.0807 26.9333 16.0807 26.432V26.112Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.002 29.16C20.53 29.16 20.906 29.0213 21.13 28.744C21.3593 28.4666 21.474 28.056 21.474 27.512V26.968C21.474 26.4293 21.3593 26.0213 21.13 25.744C20.906 25.4613 20.53 25.32 20.002 25.32H19.09V29.16H20.002ZM18.074 30V24.48H20.002C20.4553 24.48 20.842 24.5386 21.162 24.656C21.482 24.768 21.7433 24.9413 21.946 25.176C22.1486 25.4053 22.2953 25.6933 22.386 26.04C22.482 26.3813 22.53 26.7813 22.53 27.24C22.53 27.6826 22.482 28.0773 22.386 28.424C22.2953 28.7653 22.1486 29.0533 21.946 29.288C21.7433 29.5226 21.482 29.7013 21.162 29.824C20.842 29.9413 20.4553 30 20.002 30H18.074Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5896 30V24.48H27.1496V25.32H24.6056V26.872H26.5816V27.712H24.6056V30H23.5896Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon44);
export default __webpack_public_path__ + "static/media/pdf-icon-44.1452898ad541cda647d44dcce2c29404.svg";
export { ForwardRef as ReactComponent };